import App from './App.vue';
// 🎯 MIGRATION FABRIC 6.X COMPLÈTE: Plus besoin de window.fabric
// Tous les fichiers utilisent maintenant des imports directs

const app = createApp(App);
const head = createHead();
registerPlugins(app);

app.use(i18n);
app.use(head);
app.mount('#app');

/**
 * Récupération gracieuse après REDÉPLOIEMENT (Dokploy zero-downtime) : les chunks JS
 * hashés de l'ancienne version n'existent plus → l'import dynamique échoue. On
 * SAUVEGARDE le brouillon (sync) puis on recharge pour récupérer la nouvelle version.
 * Complète le `router.onError` existant (qui gère l'échec au NIVEAU navigation) en
 * couvrant l'événement Vite de préchargement.
 */
let reloadingForUpdate = false;
function showUpdatingOverlay() {
    try {
        const el = document.createElement('div');
        el.setAttribute('role', 'status');
        el.style.cssText =
            'position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;' +
            'background:rgba(23,26,31,0.72);color:#fff;font:600 15px/1.4 system-ui,sans-serif;text-align:center;padding:24px;';
        el.textContent = i18n.global.t('AppUpdating') || 'Mise à jour de l’application…';
        document.body.appendChild(el);
    } catch {
        /* overlay best-effort */
    }
}
function recoverFromChunkError() {
    if (reloadingForUpdate) {
        return;
    }
    // GARDE ANTI-BOUCLE : `reloadingForUpdate` est remis à false à chaque rechargement,
    // donc si le chunk reste introuvable (déploiement/CDN incohérent, chunk réellement
    // manquant), on recharge → échec → recharge… à l'infini. On limite à 2 tentatives
    // par fenêtre glissante de 30s (persistées en sessionStorage) : au-delà, on cesse
    // de recharger et on laisse l'app en l'état plutôt que de boucler.
    try {
        const now = Date.now();
        const WINDOW_MS = 30000;
        const MAX_RELOADS = 2;
        const raw = sessionStorage.getItem('__pxlChunkReloads');
        const hist = (raw ? (JSON.parse(raw) as number[]) : []).filter((t) => now - t < WINDOW_MS);
        if (hist.length >= MAX_RELOADS) {
            // Trop de rechargements récents → on arrête la boucle.
            return;
        }
        hist.push(now);
        sessionStorage.setItem('__pxlChunkReloads', JSON.stringify(hist));
    } catch {
        /* sessionStorage indispo : on garde le comportement d'origine (un seul reload via le flag module) */
    }
    reloadingForUpdate = true;
    try {
        // `__pxlMarkAppUpdate` et pas `__pxlSaveDraftSync` : c'est CE chemin — et
        // lui seul — qui autorise la restauration du brouillon au redémarrage.
        (window as any).__pxlMarkAppUpdate?.();
    } catch {
        /* best-effort */
    }
    showUpdatingOverlay();
    setTimeout(() => window.location.reload(), 600);
}
window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    recoverFromChunkError();
});
window.addEventListener('beforeunload', () => {
    try {
        (window as any).__pxlSaveDraftSync?.();
    } catch {
        /* best-effort */
    }
});
